import React, { useRef, useState } from 'react';
import cx from 'classnames';
import style from './generalSearchTagsMobile.module.scss';
import reverse from 'lodash-es/reverse';
import { animated, useSpring } from 'react-spring';
import { GetChipFunction } from 'hooks/useSearchControl';
import { TransitionGroup } from 'react-transition-group';
import ExpandArrowIcon from 'icons/expandArrow';
import { tagsWrapTransition } from 'components/transitionWrappers/tagsWrapTransition';
import { Tags } from 'store/types';
import { Box, Typography } from '@mui/material';

const VISIBLE_LINES_COUNT = 2;

export default function GeneralSearchTagsMobile({
  selected,
  getChip,
}: {
  selected: Tags;
  getChip: GetChipFunction;
}) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isTouchScroll, setIsTouchScroll] = useState(false);
  const [moveDelta, setMoveDelta] = useState(0);

  const [isOpen, setIsOpen] = useState(false);
  const [chipHeight, setChipHeight] = useState(0);
  const [fullHeight, setFullHeight] = useState(0);
  const collapsedHeight = chipHeight * VISIBLE_LINES_COUNT;

  const tags = tagsWrapTransition({
    tags: selected,
    getChip,
    ref: (el: HTMLDivElement | null) => {
      if (el) {
        const { height } = el.getBoundingClientRect();
        const lineHeight = Number(height + 10);
        setChipHeight(lineHeight);
        setFullHeight(el.offsetTop + lineHeight);
      }
    },
  });

  const anime = useSpring({
    maxHeight: isOpen ? fullHeight : collapsedHeight,
  });

  return (
    <>
      <animated.div
        style={anime}
        className={cx(style['container-tags'], 'noselect')}
        ref={scrollRef}
        onMouseDown={() => {
          setIsTouchScroll(true);
        }}
        onMouseMove={(e) => {
          if (isTouchScroll && scrollRef.current) {
            scrollRef.current.scrollLeft -= e.movementX;
            setMoveDelta(moveDelta + Math.abs(e.movementX));
          }
        }}
      >
        <TransitionGroup className={style.selected} component="div">
          {reverse(tags)}
        </TransitionGroup>
      </animated.div>
      {tags.length && fullHeight > collapsedHeight ? (
        <Box
          className={'adaptive-generalSearchTagsMobile__expand'}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            alignSelf: 'center',
          }}
        >
          <ExpandArrowIcon
            className={isOpen ? style.expand : ''}
          ></ExpandArrowIcon>
          <Typography
            className={'fontBold'}
            onClick={() => setIsOpen((old) => !old)}
          >
            {isOpen ? 'Cкрыть полный список' : 'Раскрыть полный список'}
          </Typography>
        </Box>
      ) : (
        ''
      )}
    </>
  );
}
